import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {Consumption} from "../interfaces/result-consumption";

/**
 * Component for showing the energy classes in the sidebar of the moderat.
 */
@Component({
    selector: 'app-sanierung-saving',
    templateUrl: './sanierung-saving.component.html',
    standalone: false
})
export class SanierungSavingComponent implements OnInit, OnChanges {
  /**
   * toggle for the loading indicator
   */
  @Input() loading: boolean = false;

  /**
   * Data of the user
   */
  @Input() anfrage: ModeratAnfrage;

  /**
   * calculated consumptions, based in the request.
   */
  @Input() consumption: Consumption;

  // translation key prefix to simplify template bindings
  textkeyPrefix = 'moderat.sanierung.saving';

  // stash energy classes and selected classes for shorter template conditions
  effizienzklassen: string[] = ['a_plus', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];

  // cached classes for performance
  demandClass: string | undefined;
  recommendClass: string | undefined;

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.updateClasses();
  }

  /**
   * @inheritDoc
   */
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.loading && !changes.loading.firstChange) || changes.anfrage) {
      // Update when loading toggles, and also on anfrage change.
      this.updateClasses();
    }
  }

  /**
   * On changes of the input, update the energy classes
   * @private
   */
  private updateClasses(): void {
    const mr = this.anfrage?.measureResult;
    this.demandClass = mr?.demand?.energy_class;
    this.recommendClass = mr?.saving?.energy_class;
  }
}
